import { _GroupItem } from './_GroupItem';
import { Group as BaseGroup } from './Group';
export var Group = Object.assign(BaseGroup, {
  Item: _GroupItem
});
//# sourceMappingURL=index.js.map